<template>
	<div class="banner">
    <div class="swiper-container">
        <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="str in listImg" ><img :src="str.url"/></div>
        </div>
    </div>
   </div>
</template>

<script>
    import Swiper from 'swiper';
    import '../../static/css/swiper.min.css';
    export default {
        props: ['listImg'],
        mounted() {
            console.log('mounted', this)
            var swiper = new Swiper('.swiper-container', {
                pagination:{
                	el:'.swiper-pagination'
                },
                paginationClickable: true,
                loop: true,
                speed: 600,
                autoplay: 4000,
                onTouchEnd: function() {
                    swiper.startAutoplay()
                }
            });
        }
    }
</script>

<style scoped>
    .banner {
    width: 1120px;
    overflow: hidden;
    margin: 0px auto 0px auto;
    display: block;
  
        .swiper-wrapper {
            width: 100%;
            height: 100%;
        }
        .swiper-slide {
            background-position: center;
            background-size: cover;
            width: 100%;
            height: 100%;
            img {
                width: 100%;
                height: 100%;
            }
        }
        .swiper-pagination-bullet {
            width:0.833rem;
            height: 0.833rem;
            display: inline-block;
            background: #7c5e53;
        }
    }
    

@media(max-width: 750px) {
    .banner{
         width: 750px;
    }  
    .swiper-wrapper img{ width: 100%;}
}       
</style>


// WEBPACK FOOTER //
// src/components/banner.vue